import { css } from '@linaria/core';
import theme from '../../../theme';

export const components = {
  icon: css``,
};

export const variants = {
  active: css``,
  interactive: css``,
};

export const badge = css`
  display: inline-flex;
  justify-content: center;
  gap: 0.25rem;
  align-items: center;
  border-radius: 1rem;
  padding: 0.25rem 1rem;
  box-shadow: ${theme.elevation.peoople};
  &.${variants.active} {
    background-color: ${theme.colors.peoople['azul-claro']};
    color: ${theme.colors.peoople['azul-claro-medio']};
  }
  &.${variants.interactive} {
    &:hover {
      background-color: ${theme.colors.peoople['azul-claro']};
    }
    &:active {
      background-color: ${theme.colors.peoople['azul-claro-medio']};
    }
  }
`;
